"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityConversionMetadataToJSON = exports.CommunityConversionMetadataFromJSONTyped = exports.CommunityConversionMetadataFromJSON = void 0;
var runtime_1 = require("../runtime");
function CommunityConversionMetadataFromJSON(json) {
    return CommunityConversionMetadataFromJSONTyped(json, false);
}
exports.CommunityConversionMetadataFromJSON = CommunityConversionMetadataFromJSON;
function CommunityConversionMetadataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'wallet': !(0, runtime_1.exists)(json, 'wallet') ? undefined : json['wallet'],
        'chain': !(0, runtime_1.exists)(json, 'chain') ? undefined : json['chain'],
        'blockNumber': !(0, runtime_1.exists)(json, 'blockNumber') ? undefined : json['blockNumber'],
        'txHash': !(0, runtime_1.exists)(json, 'txHash') ? undefined : json['txHash'],
        'passTokenIds': !(0, runtime_1.exists)(json, 'passTokenIds') ? undefined : json['passTokenIds'],
        'passAcquisitionDates': !(0, runtime_1.exists)(json, 'passAcquisitionDates') ? undefined : json['passAcquisitionDates'],
    };
}
exports.CommunityConversionMetadataFromJSONTyped = CommunityConversionMetadataFromJSONTyped;
function CommunityConversionMetadataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'wallet': value.wallet,
        'chain': value.chain,
        'blockNumber': value.blockNumber,
        'txHash': value.txHash,
        'passTokenIds': value.passTokenIds,
        'passAcquisitionDates': value.passAcquisitionDates,
    };
}
exports.CommunityConversionMetadataToJSON = CommunityConversionMetadataToJSON;
